/*
 * MySiteCare
 *
 * Copyright © 2026 Jeanjen Sisoy Luberio
 * doing business as MySiteCare Website Application Services.
 * All rights reserved.
 *
 * DTI Business Name No. 7934250
 * https://mysitecare.eu
 *
 * This file contains original proprietary MySiteCare source code,
 * except for third-party components identified under their
 * respective licenses.
 */
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import StoreShell from "@/components/store/StoreShell";
import { getCart, updateCartQuantity, removeFromCart, cartTotalMinor } from "@/lib/storeCart";

function money(minor) { return `₱${((minor || 0) / 100).toLocaleString("en-PH", { minimumFractionDigits: 2 })}`; }

export default function StoreCart() {
  const { slug } = useParams();
  const [items, setItems] = useState(() => getCart(slug));

  return (
    <StoreShell slug={slug}>
      <h1 className="text-2xl font-bold font-display text-[#0F172A] mb-4">Your Cart</h1>
      {items.length === 0 ? (
        <div className="rounded-2xl border border-[#E2E8F0] p-8 text-center">
          <p className="text-sm text-[#94A3B8]">Your cart is empty.</p>
          <Link to={`/store/${slug}`} className="mt-3 inline-block text-sm font-medium text-[#10B981] hover:underline">Continue shopping</Link>
        </div>
      ) : (
        <>
          <div className="rounded-2xl border border-[#E2E8F0] overflow-hidden">
            {items.map((item) => (
              <div key={`${item.product_id}-${item.variant_id}`} className="flex items-center justify-between gap-3 border-b border-[#E2E8F0] last:border-0 px-4 py-3.5">
                <div>
                  <p className="text-sm font-medium text-[#0F172A]">{item.name}{item.variant_name ? ` — ${item.variant_name}` : ""}</p>
                  <p className="text-xs text-[#94A3B8]">{money(item.unit_price_minor)} each</p>
                </div>
                <div className="flex items-center gap-2">
                  <input type="number" min="0" value={item.quantity}
                    onChange={(e) => setItems(updateCartQuantity(slug, item.product_id, item.variant_id, Math.max(0, Number(e.target.value))))}
                    className="w-16 rounded-lg border border-[#E2E8F0] px-2 py-1.5 text-sm" />
                  <button onClick={() => setItems(removeFromCart(slug, item.product_id, item.variant_id))} className="text-xs text-red-600 hover:underline">Remove</button>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-4 flex items-center justify-between text-lg font-bold text-[#0F172A]">
            <span>Total</span><span>{money(cartTotalMinor(items))}</span>
          </div>
          <p className="mt-1 text-xs text-[#94A3B8]">Final total (including any shipping) is confirmed at checkout.</p>
          <Link to={`/store/${slug}/checkout`} className="mt-5 block w-full rounded-xl bg-[#0F172A] px-4 py-3 text-center text-sm font-semibold text-white">Proceed to Checkout</Link>
        </>
      )}
    </StoreShell>
  );
}
